var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],staticClass:"grid grid-cols-3 gap-0 lg:-ml-0 lg:w-auto lg:gap-x-0.5 lg:gap-y-12"},_vm._l((_vm.blok.columns),function(blok){return _c('div',{key:blok._uid},[_c(blok.component,{tag:"component",attrs:{"blok":blok}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }